import { render, staticRenderFns } from "./param.vue?vue&type=template&id=7871afa8"
import script from "./param.vue?vue&type=script&lang=js"
export * from "./param.vue?vue&type=script&lang=js"
import style0 from "./param.vue?vue&type=style&index=0&id=7871afa8&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7871afa8')) {
      api.createRecord('7871afa8', component.options)
    } else {
      api.reload('7871afa8', component.options)
    }
    module.hot.accept("./param.vue?vue&type=template&id=7871afa8", function () {
      api.rerender('7871afa8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sportManage/basic/param.vue"
export default component.exports